@for (
  template of [header, price, slotWarning, cta, churn, divider, features];
  track trackByRef($index, template);
  let isFirstRow = $first;
  let isLastRow = $last
) {
  @for (pickerProduct of state().products; track trackByProduct($index, pickerProduct)) {
    <div
      class="codename-{{ pickerProduct.codename }}"
      [style.position]="'relative'"
      [class.highlight]="pickerProduct.codename === state().highlighted"
      [class.first-row]="isFirstRow"
      [class.last-row]="isLastRow"
    >
      <ng-container *ngTemplateOutlet="template; context: { $implicit: pickerProduct }" />
    </div>
  }
}

<ng-template #divider>
  <rt-divider />
</ng-template>

<ng-template #header let-pickerProduct [ngTemplateType]="templateTypeProduct">
  @if (state().highlighted === pickerProduct.codename) {
    @if (pickerProduct.codename === BillingPlanTier.Scale) {
      <div class="product-highlight-badge">
        {{ 'app.pricing.plan_picker.most_popular' | translate }}
      </div>
    }
    @if (pickerProduct.codename === BillingPlanTier.Lead) {
      <div class="product-highlight-badge">{{ 'app.pricing.recommended' | translate }}</div>
    }
  }

  <div class="grid-cell with-padding-bottom">
    <rt-plan-picker-product-header
      [codename]="pickerProduct.codename"
      [showCustomBadge]="pickerProduct.state.showCustomBadge"
      [showTrialPlanBadge]="pickerProduct.codename === BillingPlanTier.Scale && state().isTrial"
    />
  </div>
</ng-template>

<ng-template #price let-pickerProduct [ngTemplateType]="templateTypeProduct">
  <div class="grid-cell with-padding-bottom">
    @if (pickerProduct.state.showPrice) {
      <rt-plan-picker-product-price
        [interval]="state().interval"
        [currency]="Currency[pickerProduct.product!.currency]"
        [costPerMonth]="pickerProduct.state.costPerMonth"
        [costPerMonthWithoutDiscount]="pickerProduct.state.costPerMonthWithoutDiscount!"
      />
    }
    @if (!pickerProduct.state.showPrice) {
      <div text-bold text-darkest>
        {{ 'app.pricing.plan_picker.custom_pricing' | translate }}
      </div>
      <div text-darkest text-small>
        {{ 'app.pricing.plan_picker.tailored_needs' | translate }}
      </div>
    }
  </div>
</ng-template>

<ng-template #slotControl let-pickerProduct [ngTemplateType]="templateTypeProduct">
  <div class="grid-cell with-padding-bottom">
    @if (pickerProduct.state.showSlotPicker) {
      <rt-heading variant="uppercased" margin-bottom-small-x>
        {{ 'app.pricing.job_slots' | translate }}
      </rt-heading>

      <rt-job-slots-picker
        [product]="pickerProduct.product!"
        [value]="pickerProduct.state.selectedSlots"
        [ownedSlots]="pickerProduct.state.ownedSlots"
        [addContactWithSalesOption]="true"
        (slotsChange)="
          slotsChange.emit({ codename: pickerProduct.codename, value: $event });
          analytics.trackSlotsSelect(pickerProduct, $event)
        "
      />
    }
  </div>
</ng-template>

<ng-template #slotWarning let-pickerProduct [ngTemplateType]="templateTypeProduct">
  <div class="grid-cell with-padding-bottom">
    @if (pickerProduct.state.showSlotLimitMessage) {
      <rt-job-slots-limit-message
        [compact]="true"
        [numberOfJobsToArchive]="pickerProduct.limits.jobs"
      />
    }
  </div>
</ng-template>

<ng-template #cta let-pickerProduct [ngTemplateType]="templateTypeProduct">
  <div class="grid-cell">
    @if (pickerProduct.state.showCta) {
      <rt-plan-button
        [hasIcon]="false"
        [variant]="planTierButtonVariantMap[pickerProduct.codename]"
        [disabled]="pickerProduct.state.disableCta"
        (click)="selected.emit(pickerProduct)"
      >
        {{
          pickerProduct.status
            | rtPlanPickerProductCtaLabel
              : state().assignedProduct && pickerProduct.product?.id === state().assignedProduct!.id
        }}
      </rt-plan-button>
    }
  </div>
</ng-template>

<ng-template #churn let-pickerProduct [ngTemplateType]="templateTypeProduct">
  <div class="grid-cell churn" layout-centered>
    @if (pickerProduct.state.showChurn) {
      <span
        (click)="cancelSubscription.emit()"
        [style.cursor]="'pointer'"
        text-underline
        text-light
        text-weight-default
        margin-tb-small-x
      >
        {{ 'app.pricing.plan_picker.cancel_subscription' | translate }}
      </span>
    }
  </div>
</ng-template>

<ng-template #features let-pickerProduct [ngTemplateType]="templateTypeProduct">
  <div class="grid-cell with-padding-bottom" margin-top>
    <rt-heading margin-bottom-small-x>
      {{ content.featuresByCodename[pickerProduct.codename].label }}
    </rt-heading>

    <div class="features">
      <ul>
        @for (
          feature of content.featuresByCodename[pickerProduct.codename].features;
          track trackByFeature($index, feature)
        ) {
          <li>
            <rt-icon name="check" margin-right-small margin-top-small-xx />
            {{ feature }}
          </li>
        }
      </ul>
    </div>
  </div>
</ng-template>
